export const PHONE = '+393450351993';
export const EMAIL = 'eduardautoservizi@yahoo.com';
export const FIRM = '05019930238';